import { render } from "./UpdateProfileForm.vue?vue&type=template&id=3207bb20&scoped=true&ts=true"
import script from "./UpdateProfileForm.vue?vue&type=script&lang=ts"
export * from "./UpdateProfileForm.vue?vue&type=script&lang=ts"

import "./UpdateProfileForm.vue?vue&type=style&index=0&id=3207bb20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3207bb20"]])

export default __exports__